import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { NgForm } from '@angular/forms';
import { ListofvaluesService } from '../../../services/listofvalues.service';

import * as uuid from 'uuid';
@Component({
    selector: 'app-create-retention',
    templateUrl: 'createRetentionModal.component.html',
    styleUrls: ['./createRetentionModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: []
})
export class CreateRetentionModalComponent implements OnDestroy {
    RetentionItem: any = {};
    modalTitle = '';
    buttonText = '';
    subscription: Subscription;
    action: string;
    ldvType: any = [{id:'01', value: 'Factura'},{id:'03', value: 'Boleta'},];
    ldvMoney: any;

    constructor(public dialogRef: MatDialogRef<CreateRetentionModalComponent>,
        private notifierService: NotifierService,
        private listofvaluesService: ListofvaluesService,

        private zone: NgZone) {

        this.handleNotify();
        this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((result) => {
            this.ldvMoney = result;
        });
    }

    handleNotify() {
        this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
            message => {
                this.zone.run(() => {
                    this.action = message.action;

                    // tslint:disable-next-line:triple-equals
                    if (message.action == 'edit' && message.model == 'retention') {
                        this.RetentionItem = message.object.data;
                        console.log(message.object.data);
                    //    this.RetentionItem.fecha_pago = new Date(message.object.data.fecha_pago_text);
                        this.buttonText = 'Actualizar';
                        this.modalTitle = 'Editar Detalle de Comprobante';
                        // tslint:disable-next-line:triple-equals
                    } else if (message.action == 'register' && message.model == 'retention') {
                        this.RetentionItem = message.object.data;
                        this.RetentionItem.create_uuid = uuid.v4();
                        this.buttonText = 'Crear';
                        this.modalTitle = 'Crear Detalle de Comprobante';
                    }
                });

            }
        );
    }

    update(form: NgForm) {
        console.log(this.RetentionItem);
        if (form.valid) {
            if (this.RetentionItem.id) {
                this.RetentionItem.action_backend = 'U';
            } else {
                this.RetentionItem.action_backend = 'C';
            }
            this.dialogRef.close(this.RetentionItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }

    updOtros(){
        
        //this.RetentionItem.importe_retencion =  this.RetentionItem.monto_pago* 0.03;
        if (this.RetentionItem.currency == '8'){ //USD
            this.RetentionItem.importe_retencion =  (Number(this.RetentionItem.monto_pago*this.RetentionItem.tipo_cambio)*0.03).toFixed(2);
            this.RetentionItem.importe_pagar =  (Number(this.RetentionItem.monto_pago*this.RetentionItem.tipo_cambio) - Number(this.RetentionItem.monto_pago*this.RetentionItem.tipo_cambio)*0.03).toFixed(2);

        }else{
            this.RetentionItem.importe_retencion =  (Number(this.RetentionItem.monto_pago)*0.03).toFixed(2);
            this.RetentionItem.importe_pagar =  (Number(this.RetentionItem.monto_pago) - Number(this.RetentionItem.monto_pago)*0.03).toFixed(2);

        }


    }
    create(form: NgForm) {
        if (form.valid) {
            if (this.RetentionItem.currency =='8' && this.RetentionItem.tipo_cambio ==''){
                this.notifierService.systemNotify({
                    title: 'Ha ocurrido un error',
                    message: 'Por favor complete el tipo de cambio ',
                    type: 'error'
                });
            }
            this.RetentionItem.action_backend = 'C';
            this.dialogRef.close(this.RetentionItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete todos los campos ',
                type: 'error'
            });
        }
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/system/retention/new-retention/createRetentionModal/createRetentionModal.component.ts